import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as validate from './FormValidation';
import {scrollToFirstError} from '../helpers/ReduxFormScrollToError';
import {Button, Divider, Icon, Alert} from 'antd';



const FormSonstiges = props => {
    const { handleSubmit, saving, pristine, reset, submitting, back } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="content">
                <Divider orientation={"left"}>Sonstige Angaben</Divider>
                <Field
                    name="Sonst_Angaben"
                    label="Sonstiges:"
                    type="text"
                    max={440}
                    component={validate.renderTextarea}

                />

                <Alert
                    message="Folgende Unterlagen sind für die Bearbeitung Ihres Antrags erforderlich"
                    description="
                        Lageplan M 1:1000 und Bauplan M 1:100
                        Pläne in elektrischer Form (pdf, jpg, tif) einfach am Ende des Antrages mit Hochladen oder
                        Pläne in Papierform per Post schicken, diese werden nach Bearbeitung zurückgesandt
                        "
                    type="warning"
                    showIcon
                />

                <Field
                    name="files"
                    label="Anhänge:"
                    component={validate.renderFileField}

                />
                <br/>
                <Field
                    name="einverständniserklaerung"
                    label="Ich/Wir erkläre/n, dass ich/wir die Wasserabgabesatzung und die Beitrags- und Gebührensatzung zur Wasserabgabesatzung des Wasserzweckverbandes Rottenburger Gruppe anerkenne/n."
                    component={validate.renderCheckbox}
                    validate={validate.required}
                />
                <a target="_blank" href="https://www.rottenburger-gruppe.de/export/download.php?id=46">Beitrags- und Gebührensatzung zur Wasserabgabesatzung</a>
                <br/>
                <a target="_blank" href="https://www.rottenburger-gruppe.de/export/download.php?id=304">Wasserabgabesatzung</a>
                <br/><br/>
                <Field
                    name="datenschutzerklaerung"
                    label="Ich habe die Datenschutzerklärung und die Datenschutzhinweise zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten zur Bearbeitung elektronisch erhoben und gespeichert werden."
                    component={validate.renderCheckbox}
                    validate={validate.required}
                />
                <a target="_blank" href="https://www.rottenburger-gruppe.de/index.php?id=0,57">Datenschutzerklärung</a><br/>
                <a target="_blank" href="https://www.rottenburger-gruppe.de/export/download.php?id=770">Datenschutzhinweise</a>
                <br/>


                <div className={"right-container"}>
                    <Button type={"default"} htmlType={"button"} onClick={back}><Icon type={"left"}/> Zurück</Button>
                    <Button className={"pull-right"} type={"primary"} htmlType={"submit"} disabled={saving} loading={saving}><Icon type={"check"}/> Fertigstellen</Button>
                </div>


            </div>
        </form>
    );
};



let FormSonstigesRedux = reduxForm({
    form: 'auftragform',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(FormSonstiges);



export default FormSonstigesRedux;



// WEBPACK FOOTER //
// ./src/components/FormSonstiges.js